import type { FieldConfig, AvatarOption } from '../common/ui/types';
import { archivedByFilterOptions } from './archivedby-mock-data';
import { filterFields } from './constants';
import { issueTypeFields } from './issue-type-filter-mock-data';
import { reporterFilterOptions } from './reporter-mock-data';

export const getFilterFieldConfig = () => {
	const issueTypes = issueTypeFields?.data?.node?.getArchivedIssuesFilterOptions?.issueTypes?.edges;
	const reporters =
		reporterFilterOptions?.data?.node?.getArchivedIssuesFilterOptions?.reporters?.edges;
	const archivedBy =
		archivedByFilterOptions?.data?.node?.getArchivedIssuesFilterOptions?.archivedBy?.edges;
	const fieldConfig: FieldConfig = {};
	type FilterOptionMapping = {
		[key: string]: AvatarOption[];
	};
	const filterFieldsMap: FilterOptionMapping = {
		issueType: issueTypes.map((issueType) => ({
			...issueType,
			label: issueType.name,
			avatar: issueType.avatar.medium,
			square: true,
			value: issueType.name,
			hierarchyLevel: issueType?.hierarchy?.level,
			id: issueType.issueTypeId,
		})),
		reporter: reporters.map((reporter) => ({
			...reporter,
			label: reporter.name,
			value: reporter.accountId,
			avatar: reporter.picture,
		})),
		archivedBy: archivedBy.map((archivedByNode) => ({
			...archivedByNode,
			label: archivedByNode.name,
			value: archivedByNode.accountId,
			avatar: archivedByNode.picture,
		})),
	};

	Object.keys(filterFields).forEach((field: string) => {
		if (filterFieldsMap[field] && filterFields[field]) {
			filterFields[field].options = filterFieldsMap[field];
			fieldConfig[field] = filterFields[field];
		} else {
			fieldConfig[field] = filterFields[field];
		}
	});

	return { fieldConfig };
};
